var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper",style:({
    background: _vm.hovered ? '#fff' : _vm.icons[_vm.channel.key].baseColor,
    border: `2px solid ${
      _vm.channel.key === 'MESSENGER' || _vm.channel.key === 'INSTAGRAM'
        ? _vm.hovered
          ? _vm.icons[_vm.channel.key].borderColor
          : 'transparent'
        : _vm.icons[_vm.channel.key].baseColor
    }`,
    color: _vm.hovered ? _vm.icons[_vm.channel.key].baseColor : '#fff',
  }),domProps:{"innerHTML":_vm._s(_vm.getIconSvg(_vm.channel.key))}})
}
var staticRenderFns = []

export { render, staticRenderFns }